// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
  apiKey: "AIzaSyCENt0gLxbPS9YVXkhBJCmVMDN4GWHubPI",
  authDomain: "test-rodov-index-84019.firebaseapp.com",
  databaseURL: "https://test-rodov-index-84019-default-rtdb.firebaseio.com",
  projectId: "test-rodov-index-84019",
  storageBucket: "test-rodov-index-84019.appspot.com",
  messagingSenderId: "872032953857",
  appId: "1:872032953857:web:527a6d3a25467f67d44200",
  measurementId: "G-N56FM0XPDF"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
